import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/EtablissementGallery.scss";
import Slider from "react-slick";
import Modal from 'react-bootstrap/Modal'; // Make sure to import Modal

const EtablissementGallery = ({ photos, status }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const featuredPhoto =
    photos && photos?.length > 0
      ? photos?.find((photo) => photo?.featured === 1) || photos[0]
      : null;

  const otherPhotos =
    photos && photos.length > 0
      ? photos.filter((photo) => photo.id !== featuredPhoto?.id)
      : [];
  const displayedPhotos = otherPhotos.slice(0, 4);
  const hasMorePhotos = otherPhotos.length > 4;
  const lastDisplayedPhoto = displayedPhotos[displayedPhotos.length - 1];

  // Custom arrow components
  const NextArrow = (props) => {
    const { className, style, onClick, currentSlide, slideCount } = props;
    const isLastSlide = currentSlide === slideCount - 1;
    return (
      <div
        className={`${className} custom-arrow`}
        style={{
          ...style,
          display: "block",
          paddingLeft: "15px",
        }}
        onClick={(e) => {
          if(!isLastSlide){
             e.stopPropagation();
          onClick();  
          }
       
        }}
      />
    );
  };

  const PrevArrow = (props) => {
    const { className, style, onClick, currentSlide } = props;
    const isFirstSlide = currentSlide === 0;
    return (
      <div
        className={`${className} custom-arrow`}
        style={{
          ...style,
          display: "block",
          left: "-40px",
          paddingRight: "15px",
          zIndex: 1,
        }}
        onClick={(e) => {
          if(!isFirstSlide){
            e.stopPropagation();
          onClick();  
          }
        
        }}
      />
    );
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => setCurrentSlide(next),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => (
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "absolute",
          bottom: "20px",
          width: "100%",
        }}
      >
        <ul style={{ margin: "0", padding: "0" }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <button
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          border: "none",
          margin: "0 5px",
          padding: "0",
          backgroundColor: "rgba(255,255,255,0.5)",
        }}
      />
    ),
  };

  if (status === "loading") {
    return (
      <div className="col-12">
        <div className="etablissement-gallery mt-16">
          <div className="gallery-container">
            <div className="featured-photo">
              <Skeleton width="100%" height={300} />
            </div>
            <div className="grid-photos">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="grid-item">
                  <Skeleton width="100%" height={150} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!photos || photos.length === 0) {
    return <div>No photos available</div>;
  }

  return (
    <div className="col-12">
      <div className="etablissement-gallery mt-16">
        <div className="gallery-container">
          <div
            className="featured-photo"
            onClick={() => setShowModal(true)}
          >
            <img
              src={`${process.env.REACT_APP_FILE_URL}${featuredPhoto?.url_photo}`}
              alt={featuredPhoto?.name}
            />
          </div>
          <div className="grid-photos">
            {displayedPhotos.map((photo, index) => {
              const borderRadiusClass = 
                index === 3 ? "rounded-br-lg" : 
                index === 1 ? "rounded-tr-lg" : "";

              return (
                <div
                  key={photo.id}
                  className={`${
                    hasMorePhotos && photo.id === lastDisplayedPhoto.id
                      ? "relative"
                      : ""
                  } grid-item ${borderRadiusClass}`}
                  onClick={() => setShowModal(true)}
                >
                  <img
                    src={`${process.env.REACT_APP_FILE_URL}${photo?.url_photo}`}
                    alt={photo?.name}
                    className={`w-full h-full object-cover ${borderRadiusClass}`}
                  />
                  {hasMorePhotos && photo.id === lastDisplayedPhoto.id && (
                    <div className="see-all-overlay">
                      Voir toutes les photos
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* New Modal Implementation */}
        <Modal 
          show={showModal} 
          onHide={() => setShowModal(false)} 
          className="twyny-modal min-w-100"
          style={{top:'60px'}}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            
          </Modal.Header>
          <Modal.Body>
            <div className="slider-container">
              <Slider {...sliderSettings}>
                {photos.map((photo) => (
                  <div key={photo.id} className="slide-item" style={{display:'flex',justifyContent:'center'}}>
                    <img
                      src={`${process.env.REACT_APP_FILE_URL}${photo?.url_photo}`}
                      alt={photo?.name}
                      className=""
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default EtablissementGallery;